import { WhereClauseWithCompoundExpression } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isWhereClauseCompoundExpression } from "./isWhereClauseCompoundExpression";

/**
 * Type guard to check if a value is a WhereClauseWithCompoundExpression.
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseWithCompoundExpression
 */
export const isWhereClauseWithCompoundExpression = (
  obj: unknown,
): obj is WhereClauseWithCompoundExpression => {
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  const chkObj = obj as { condition?: unknown; compoundExpression?: unknown };

  // Must have a valid compoundExpression
  if (!isWhereClauseCompoundExpression(chkObj.compoundExpression)) return false;

  // Must not have condition property
  if (chkObj.condition !== undefined) return false;

  return true;
};
